import { useCatalogFetchers } from "@/shared/catalogs/hooks/useCatalogs";
import { useAssetDetailsContext } from "../../../../context/assetDetailsContext";

type Props = {
	setIsLoading: (isLoading: boolean) => void;
	setError: (err: string) => void;
};

// The full catalog comes from the shared cache, so opening this picker after another one costs
// nothing. Filtering happens in the grid, which is why the search argument is no longer used.
export const useSearchDocuments = ({ setIsLoading, setError }: Props) => {
	const {
		actions: { setListAllDocuments },
	} = useAssetDetailsContext();
	const { fetchDocumentsCatalog } = useCatalogFetchers();

	return async (_documentSearch?: string) => {
		setIsLoading(true);
		try {
			const rowsSource = await fetchDocumentsCatalog();
			// The grid expects a map keyed by document name, trimmed: DOCS.Documents carries
			// trailing spaces on some rows while the links do not.
			const allDocumentMap: any = {};
			rowsSource.forEach((row: any) => {
				allDocumentMap[row.DocumentName?.trim()] = row;
			});
			setListAllDocuments(allDocumentMap);
		} catch (e: any) {
			setError(e?.message || "Error fetching the documents catalog");
		} finally {
			setIsLoading(false);
		}
	};
};
